import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../context/GlobalContext";
import Cookies from "universal-cookie";
import "../../styles/dashboard.css";
import { Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import NavDropdown from "react-bootstrap/NavDropdown";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { CiSearch } from "react-icons/ci";
import axios from "../../../api/axios";
import helpers from "../../../utils/helpers";

const cookies = new Cookies();

const DataTable = ({ data, status, setRefreshData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useContext(GlobalContext);
  const isDashboard = location.pathname === "/" ? true : false;
  const isNotcompleted =
    location.pathname === "/applications/not-completed" ? true : false;
  const isArchived =
    location.pathname === "/applications/archived" ? true : false;
  const [selectedApplication, setSelectedApplication] = useState("");

  const [openReferModal, openOpenReferModal] = React.useState(false);
  const [referStep, setReferStep] = useState("search"); // 'search' | 'confirm'
  const [pendingReferUser, setPendingReferUser] = useState(null); // { id, username }
  const [referLoading, setReferLoading] = useState(false);
  const [openUnassignModal, setOpenUnassignModal] = useState(false);
  const [pendingUnassign, setPendingUnassign] = useState(null); // { uuid, name }
  const [unassignLoading, setUnassignLoading] = useState(false);
  const [openArchiveModal, setOpenArchiveModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [companyUsers, setCompanyUsers] = useState([]);
  const isShowOffers = state?.user?.isShowOffers;
  // Purple Wave columns/details are only for the Purple Wave company's users
  // (decided by the backend from PURPLE_WAVE_COMPANY_ID).
  const isPurpleWaveAccount = Boolean(state?.user?.is_purple_wave_account);

  const [showAlert, setShowAlert] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [sendingReminderUuid, setSendingReminderUuid] = useState(null);

  const handleCloseReferModal = () => {
    openOpenReferModal(false);
    setReferStep("search");
    setPendingReferUser(null);
    setSearchString("");
  };

  const handleSendReminder = async (uuid) => {
    setSendingReminderUuid(uuid);
    try {
      const response = await axios.post(
        `lender/partial-application/send-reminder/?uuid=${uuid}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        setOpen2(true);
        setShowAlert("Reminder email sent to the applicant.");
      }
    } catch (error) {
      setOpenSnackbar(true);
      const httpStatus = error?.response?.status;
      const detail = error?.response?.data?.detail;
      if (httpStatus === 403) {
        setErrMsg("You don't have permission to send a reminder for this application.");
      } else if (httpStatus === 404) {
        setErrMsg("Application not found.");
      } else if (detail === "Applicant email not found") {
        setErrMsg("No email address is on file for this applicant.");
      } else {
        setErrMsg("Something went wrong. Please try again.");
      }
    } finally {
      setSendingReminderUuid(null);
    }
  };

  const handleCloseArchiveModal = () => {
    setOpenArchiveModal(false);
  };

  const handleCloseErrorSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleCloseSuccessSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen2(false);
  };

  const getCompanyUsers = async () => {
    try {
      const response = await axios.get(
        `lender/list/company-users/?search=${searchString}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        }
      );
      setCompanyUsers(response?.data);
    } catch (error) {
      setCompanyUsers([]);
    }
  };

  useEffect(() => {
    getCompanyUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString]);

  const handlePickReferUser = (user) => {
    setPendingReferUser(user);
    setReferStep("confirm");
  };

  const handleConfirmReferUser = async () => {
    if (!pendingReferUser) return;
    setReferLoading(true);
    try {
      const response = await axios.put(
        "lender/refer/application/",
        {
          referring_user_id: pendingReferUser.id,
          application_uuid: selectedApplication,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        setSelectedApplication("");
        handleCloseReferModal();
        setOpen2(true);
        setShowAlert(
          `Application successfully referred to ${pendingReferUser.username}.`
        );
        setRefreshData((state) => !state);
      }
    } catch (error) {
      setOpenSnackbar(true);
      setErrMsg("Something went wrong. Please try again.");
    } finally {
      setReferLoading(false);
    }
  };

  const handleOpenUnassignModal = (uuid, name) => {
    setPendingUnassign({ uuid, name });
    setOpenUnassignModal(true);
  };

  const handleCloseUnassignModal = () => {
    setOpenUnassignModal(false);
    setPendingUnassign(null);
  };

  const handleConfirmUnassign = async () => {
    if (!pendingUnassign) return;
    setUnassignLoading(true);
    try {
      const response = await axios.delete(
        `lender/refer/application/?application_uuid=${pendingUnassign.uuid}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        handleCloseUnassignModal();
        setOpen2(true);
        setShowAlert(
          `${pendingUnassign.name} has been unassigned from this application.`
        );
        setRefreshData((state) => !state);
      }
    } catch (error) {
      setOpenSnackbar(true);
      setErrMsg("Something went wrong. Please try again.");
    } finally {
      setUnassignLoading(false);
    }
  };

  const handleChangeApplicationStatus = async () => {
    try {
      const response = await axios.put(
        `lender/change/application-status/`,
        { application_uuid: selectedApplication, status: "Archived" },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${cookies.get("access")}`,
          },
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        setSelectedApplication("");
        handleCloseArchiveModal();
        setOpen2(true);
        setShowAlert("Application archived");
        setRefreshData((state) => !state);
      }
    } catch (error) {
      setOpenSnackbar(true);
      setErrMsg("Server error");
    }
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (openReferModal) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openReferModal]);

  return (
    <>
      {errMsg && (
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseErrorSnackbar}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleCloseErrorSnackbar}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errMsg}
          </Alert>
        </Snackbar>
      )}
      {showAlert && (
        <Snackbar
          open={open2}
          autoHideDuration={6000}
          onClose={handleCloseSuccessSnackbar}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleCloseSuccessSnackbar}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {showAlert}
          </Alert>
        </Snackbar>
      )}
      <div className="refer-model-div">
        <Dialog
          open={openReferModal}
          onClose={handleCloseReferModal}
          scroll="body"
          aria-labelledby="refer-dialog-title"
          aria-describedby="refer-dialog-description"
          fullWidth
          maxWidth="xs"
        >
          {referStep === "search" ? (
            <>
              <DialogTitle id="refer-dialog-title">
                Refer Application to a Team Member
              </DialogTitle>
              <DialogContent dividers>
                <p
                  id="refer-dialog-description"
                  style={{ fontSize: "0.85rem", color: "#475569", marginBottom: "1rem" }}
                >
                  Choose a colleague below to assign as the referrer for this
                  application. They will be linked to the application and can
                  follow up with the applicant directly.
                </p>
                <div className="icon-field">
                  <CiSearch className="ms-2 icon-search" />
                  <input
                    className="search-here input-filed search-bar-field"
                    type="text"
                    aria-label="Search team members"
                    placeholder="Search team members..."
                    value={searchString}
                    onChange={(e) => setSearchString(e.target.value)}
                  />
                </div>
                <DialogContentText
                  ref={descriptionElementRef}
                  tabIndex={-1}
                  component="div"
                >
                  {companyUsers.length === 0 ? (
                    <p
                      className="text-center text-muted mt-3"
                      style={{ fontSize: "0.82rem" }}
                    >
                      No team members found.
                    </p>
                  ) : (
                    <ul className="mt-3" style={{ paddingLeft: 0 }}>
                      {companyUsers.map((user) => (
                        <li
                          key={user.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "6px 0",
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <span style={{ fontSize: "0.88rem", color: "#1e293b" }}>
                            {user.username}
                          </span>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handlePickReferUser(user)}
                          >
                            Assign →
                          </Button>
                        </li>
                      ))}
                    </ul>
                  )}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button variant="light" onClick={handleCloseReferModal}>
                  Cancel
                </Button>
              </DialogActions>
            </>
          ) : (
            <>
              <DialogTitle id="refer-dialog-title">
                Confirm Referral
              </DialogTitle>
              <DialogContent dividers>
                <p style={{ fontSize: "0.85rem", color: "#475569", marginBottom: "1rem" }}>
                  You are about to assign the following team member as the
                  referrer for this application:
                </p>
                <div
                  style={{
                    background: "#f0f9ff",
                    border: "1px solid #bae6fd",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "1rem",
                  }}
                >
                  <span
                    style={{
                      fontSize: "1.4rem",
                      lineHeight: 1,
                    }}
                  >
                    👤
                  </span>
                  <strong style={{ fontSize: "0.95rem", color: "#0c4a6e" }}>
                    {pendingReferUser?.username}
                  </strong>
                </div>
                <p style={{ fontSize: "0.82rem", color: "#64748b" }}>
                  Once confirmed, this person will be recorded as the referrer
                  and associated with this application going forward.
                </p>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="light"
                  onClick={() => setReferStep("search")}
                  disabled={referLoading}
                >
                  ← Back
                </Button>
                <Button
                  variant="primary"
                  onClick={handleConfirmReferUser}
                  disabled={referLoading}
                  style={{ minWidth: "100px" }}
                >
                  {referLoading ? (
                    <CircularProgress size={16} style={{ color: "#fff" }} />
                  ) : (
                    "Confirm"
                  )}
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      </div>
      <div className="unassign-modal-div">
        <Modal show={openUnassignModal} onHide={handleCloseUnassignModal} centered>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1rem" }}>Unassign Referrer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ fontSize: "0.85rem", color: "#475569", marginBottom: "1rem" }}>
              You are about to remove the following team member as the referrer
              for this application:
            </p>
            <div
              style={{
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                borderRadius: "8px",
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "1rem",
              }}
            >
              <span style={{ fontSize: "1.4rem", lineHeight: 1 }}>👤</span>
              <strong style={{ fontSize: "0.95rem", color: "#9a3412" }}>
                {pendingUnassign?.name}
              </strong>
            </div>
            <p style={{ fontSize: "0.82rem", color: "#64748b" }}>
              This person will no longer be associated with this application as
              a referrer.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={handleCloseUnassignModal}
              disabled={unassignLoading}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleConfirmUnassign}
              disabled={unassignLoading}
              style={{ minWidth: "100px" }}
            >
              {unassignLoading ? (
                <CircularProgress size={16} style={{ color: "#fff" }} />
              ) : (
                "Unassign"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="archive-model-div">
        <Modal show={openArchiveModal} onHide={handleCloseArchiveModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Move</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to move application to archive?
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn btn-light d-flex align-items-center justify-content-center ms-2"
              style={{ width: "73.99px" }}
              onClick={handleCloseArchiveModal}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              type="submit"
              className="btn btn-danger d-flex align-items-center justify-content-center ms-2"
              style={{ width: "73.99px" }}
              onClick={handleChangeApplicationStatus}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="table-scroll">
      <Table className="table-backgorund">
        <thead className="table-head">
          <tr>
            <th className="table-width">Created Time</th>
            {state?.user?.role !== "Individual" && (
              <th lassName="table-width">Created By</th>
            )}
            {!isNotcompleted && <th lassName="table-width">Refered To</th>}
            <th lassName="table-width">{isNotcompleted ? "Lead Owner" : "Opportunity Owner"}</th>
            <th>Equipment Name</th>
            <th>Company Name</th>
            <th>First Name</th>
            <th>Last Name</th>
            {isPurpleWaveAccount && <th>PW Customer #</th>}
            <th className="table-phone-width">Phone</th>
            <th className="table-width">Email</th>
            <th className="table-width">IP Address</th>
            {state?.user?.is_sales_rep_flow_enabled && !isNotcompleted && (
              <>
              <th>Representative First Name</th>
              <th>Representative Last Name</th>
              </>
            )}
            <th>Equipment Price</th>
            {isDashboard && <th>Status</th>}
            <th>Last Modified</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <>
              <div style={{ marginBottom: "0.5rem" }}></div>
              <tr
                style={{
                  cursor: "default",
                }}
              >
                <td>
                  {helpers.formatDateTime(item?.created_at)}
                </td>
                {state?.user?.role !== "Individual" && (
                  <td>
                    {item?.created_by}
                  </td>
                )}
                {!isNotcompleted && (
                  <td>
                    {item?.referred_to}
                  </td>
                )}
                <td>
                  {item?.owner}
                </td>
                <td>
                  {(() => {
                    const equipmentName = [item?.year, item?.make, item?.model]
                      .filter(Boolean)
                      .join(", ");
                    const listingUrl = item?.equipment_url;
                    return (
                      <>
                        {listingUrl ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 0, hide: 0 }}
                            trigger={["hover", "focus"]}
                            overlay={<Tooltip id={`asset-link-${item?.uuid}`}>Asset Site Link</Tooltip>}
                          >
                            <a
                              href={listingUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ cursor: "pointer" }}
                              aria-label="Asset Site Link"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {equipmentName || listingUrl}
                            </a>
                          </OverlayTrigger>
                        ) : (
                          equipmentName
                        )}
                        {isPurpleWaveAccount && item?.purple_wave_icn && (
                          <div style={{ fontSize: "0.85em", color: "#666", marginTop: "2px" }}>
                            ICN: {item.purple_wave_icn}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </td>
                <td>
                  {item?.company_name}
                </td>
                <td>
                  {item?.first_name}
                </td>
                <td>
                  {item?.last_name}
                </td>
                {isPurpleWaveAccount && (
                  <td>
                    {item?.purple_wave_customer_number}
                  </td>
                )}
                <td>
                  {item?.phone_no}
                </td>
                <td>
                  {item?.email}
                </td>
                <td>
                  {item?.ip_address}
                </td>
                {state?.user?.is_sales_rep_flow_enabled && !isNotcompleted && (
                  <>
                    <td>{item?.sales_rep_first_name}</td>
                    <td>{item?.sales_rep_last_name}</td>
                  </>
                )}
                <td>
                  {item?.equipment_price}
                </td>
                {isDashboard && (
                  <td>
                    {item?.status}
                  </td>
                )}
                <td>
                  {helpers.formatDateTime(item?.updated_at)}
                </td>
                <td>
                  {isNotcompleted ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 0, hide: 0 }}
                      trigger={["hover", "focus"]}
                      overlay={
                        <Tooltip id={`reminder-${item?.uuid}`}>
                          Send a reminder email to the applicant to complete their application
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="outline-primary"
                        size="sm"
                        disabled={sendingReminderUuid === item?.uuid}
                        onClick={() => handleSendReminder(item?.uuid)}
                        style={{ whiteSpace: "nowrap", minWidth: "120px" }}
                      >
                        {sendingReminderUuid === item?.uuid ? (
                          <>
                            <CircularProgress size={12} style={{ marginRight: "6px" }} />
                            Sending…
                          </>
                        ) : (
                          "Send Reminder"
                        )}
                      </Button>
                    </OverlayTrigger>
                  ) : (
                    <button className="action-btn" style={{ cursor: "pointer" }}>
                      <NavDropdown
                        title={
                          <span className="p-1 link-click-II">Action</span>
                        }
                        id="nav-dropdown"
                      >
                        {item?.equipment_use === "Business" && (
                          <NavDropdown.Item>
                            <span
                              className="p-1  font-show"
                              onClick={() =>
                                navigate(`/applications/${item?.uuid}` , {
                                  state: {
                                    year: item?.year ?? "",
                                    make: item?.make ?? "",
                                    model: item?.model ?? "",
                                    equipment_url: item?.equipment_url ?? "",
                                    purple_wave_icn: item?.purple_wave_icn ?? "",
                                  },
                                })
                              }
                            >
                              Show deal
                            </span>
                          </NavDropdown.Item>
                        )}
                        {isShowOffers && (
                          <NavDropdown.Item>
                            <span
                              className="p-1  font-show"
                              onClick={() =>
                                navigate(`/applications/${item?.uuid}/offers`)
                              }
                            >
                              Show offers
                            </span>
                          </NavDropdown.Item>
                        )}
                        {!isNotcompleted && (
                          <NavDropdown.Item>
                            {item?.referred_to ? (
                              <span
                                className="p-1 font-show"
                                onClick={() => {
                                  handleOpenUnassignModal(item?.uuid, item?.referred_to);
                                }}
                              >
                                Unassign Referrer
                              </span>
                            ) : (
                              <span
                                className="p-1 font-show"
                                onClick={() => {
                                  setSelectedApplication(item?.uuid);
                                  setReferStep("search");
                                  setPendingReferUser(null);
                                  openOpenReferModal(true);
                                }}
                              >
                                Assign Referrer
                              </span>
                            )}
                          </NavDropdown.Item>
                        )}
                        {!isArchived && (
                          <NavDropdown.Item>
                            <span
                              className="p-1  font-show"
                              onClick={() => {
                                setSelectedApplication(item?.uuid);
                                setOpenArchiveModal(true);
                              }}
                            >
                              Archive app
                            </span>
                          </NavDropdown.Item>
                        )}
                      </NavDropdown>
                    </button>
                  )}
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </Table>
      </div>
    </>
  );
};

export default DataTable;
